import { ClaimDetailEstimateDetail } from '@/components/Domains/Claims/Views/ClaimDetailEstimateDetail'
import { EstimateIdSchema } from '@eigtech/claims-v2-types'
import { EstimateCornSchema } from '@eigtech/estimates-types'
import { EstimateLineItemsDetail } from '@eigtech/ui-shared-estimates-web'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { withRequiredPermissions } from '../../../../../lib/permissions'

const ParamsSchema = z.object({
  estimateId: EstimateIdSchema.or(EstimateCornSchema),
  claimNumber: z.string(),
})

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/estimates_/$estimateId')({
  component: RouteComponent,
  parseParams: ParamsSchema.parse,
})

function RouteComponent() {
  const { claimNumber, estimateId } = Route.useParams()

  const estimateCorn = EstimateCornSchema.safeParse(estimateId)

  return estimateCorn.success ? (
    <WrappedEstimateLineItemsDetail claimNumber={claimNumber} estimateId={estimateCorn.data} />
  ) : (
    <ClaimDetailEstimateDetail />
  )
}

const WrappedEstimateLineItemsDetail = withRequiredPermissions(EstimateLineItemsDetail, {
  requiredPermissions: {
    action: 'read',
    subject: 'estimate',
  },
})
